module.exports = __webpack_public_path__ + "static/media/Quartzo-biena-textura.d00bda60.png";